import { useConfiguredForm } from '@wyz/ui';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  IAnonymizedSupplierPlatform,
  ISupplierTemplateForm,
  TabGroupType,
  TabItemType,
} from '~/connect/types';
// eslint-disable-next-line @wyz/module/no-relative-import
import BaseAlphabeticalList from './base-alphabetical-list';

const matchSupplier = (
  { supplierPlatform }: IAnonymizedSupplierPlatform,
  searchQuery: string,
) => {
  return (
    supplierPlatform.supplier.code
      ?.trim()
      .toLowerCase()
      .includes(searchQuery.trim().toLowerCase()) ||
    supplierPlatform.supplier.name
      .trim()
      .toLowerCase()
      .includes(searchQuery.trim().toLowerCase())
  );
};

const SupplierAlphabeticalList: React.FC<{
  currentTab: TabItemType['groupFilterValue'];
  searchQuery?: string;
  onAdd: (supplierPlatform: IAnonymizedSupplierPlatform) => void;
  onRemove: (id: number) => void;
  itemsByTab: TabGroupType<IAnonymizedSupplierPlatform>[string];
}> = ({ itemsByTab, searchQuery, currentTab, onAdd, onRemove }) => {
  const methods = useFormContext<ISupplierTemplateForm>();
  const configurationContext = useConfiguredForm();

  return (
    <BaseAlphabeticalList.Container>
      <BaseAlphabeticalList.Letters
        getLetterKey={(letter) => `${currentTab}-${letter}`}
        itemsByLetter={itemsByTab}
      />
      <BaseAlphabeticalList.List
        itemsByLetter={itemsByTab}
        getLetterKey={(letter) => `${currentTab}-${letter}`}
        getItemIdentifier={({ supplierPlatform }) =>
          String(supplierPlatform.supplier.id)
        }
        getItemLabel={({ supplierPlatform }) => supplierPlatform.supplier.name}
        isAdded={({ supplierPlatform }) =>
          Boolean(
            methods
              .getValues('suppliers')
              .find((_item) => _item.wyzApiId === supplierPlatform.supplier.id),
          )
        }
        canConfigure={configurationContext.mode !== 'READ_ONLY'}
        canAdd={configurationContext.mode !== 'READ_ONLY'}
        canRemove={configurationContext.mode !== 'READ_ONLY'}
        onAdd={onAdd}
        onRemove={({ supplierPlatform }) =>
          onRemove(supplierPlatform.supplier.id)
        }
        preFilterer={(supplierPlatform) =>
          !searchQuery ? true : matchSupplier(supplierPlatform, searchQuery)
        }
      />
    </BaseAlphabeticalList.Container>
  );
};

export default SupplierAlphabeticalList;
